import { render } from "./CompanyReportCWKDetails.vue?vue&type=template&id=7a49b56c&ts=true"
import script from "./CompanyReportCWKDetails.vue?vue&type=script&lang=ts"
export * from "./CompanyReportCWKDetails.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__